<template>
    <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de Sinistros Acordo Parcelamentos</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div>
                                </div>
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table v-if="ListSinistros!=''" :headers="headers" :items="ListSinistros"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina"
                                    :search-value="searchValue">
                                    <template #item-sttDtVencimento="item">
                                        <span> {{ item.sttDtVencimento !== null ? formattedDate(item.sttDtVencimento) : null }}</span>
                                    </template>
                                    <template #item-sttValorPrincipal="item">
                                        <span> {{ item.sttValorPrincipal !== null ? formatarValor(item.sttValorPrincipal) : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                       <v-btn icon @click="ConfirmaPgto(item)" style="margin-right: 10px;"
                                            variant="text" v-if="item.stlId == 10">
                                            <v-icon class="editiconcor">mdi-cash</v-icon>
                                            <v-tooltip activator="parent" location="top">Confirmar Pagamento</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <v-dialog v-model="dialogPagamento" persistent transition="dialog-bottom-transition" style="width: 600px;">
            <v-card>
                <v-card-text style="padding: 16px 0px 10px" v-if="itemAtual != ''">
                    <v-form>
                        <v-container>
                            <v-row>
                                 <v-col cols="12" md="12">
                                    <strong>Título: {{itemAtual.sttId }}</strong> -  {{ itemAtual.sttDescricao }}
                                </v-col>
                                <v-col cols="12" md="12">
                                    <strong>Cliente: {{itemAtual.pedDescricao }}</strong>
                                </v-col>
                                <v-col cols="12" md="6" style="padding-top: 25px;">
                                    <label>Valor Original</label>
                                    R$ {{ formatarValor(TituloPagamento.stpValorPrincipal) }}<br/>
                                     <label style="font-size: 20px !important;font-weight: 600;">Valor Total R$ {{ totalBR }}</label> 
                                </v-col>
                                 <v-col cols="12" md="3">
                                    <label>Valor Juros</label>
                                    <input v-model="TituloPagamento.stpValorJuro" v-decimal class="form-control"
                                        placeholder="Valor v" />
                                </v-col>
                                 <v-col cols="12" md="3">
                                    <label>Valor Mora</label>
                                    <input v-model="TituloPagamento.stpValorMora" v-decimal class="form-control"
                                        placeholder="Valor Mora" />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <label>Pagamento</label>
                                    <input v-model="TituloPagamento.stpDtPagamento" type="date" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                                  <v-col cols="12" md="6">
                                    <label>Cód Pagamento</label>
                                    <input v-model="TituloPagamento.stpCodigoPagto" type="text" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                                <div class="col-md-12 col-lg-12" style="padding: 5px;">
                                    <div class="form-group">
                                        <label>Observações</label>
                                        <textarea cols="5" rows="3" style="width: 100%;" v-model="TituloPagamento.stpObservacao" class="form-control" maxlength="255"
                                            placeholder="Observações">
                                        </textarea>
                                    </div>
                                </div>
                                 <v-col cols="12" md="12">
                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                            PDF</label>
                                        <v-file-input v-model="selectedFileDebito"
                                            label="Selecione o arquivo" variant="underlined"
                                            prepend-icon="mdi-file"
                                            accept="image/*,application/pdf"></v-file-input>
                                    </v-col>
                            </v-row>

                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="" style="padding: 5px;margin: 5px;font-size: 13px;color:#000000;"
                        @click.prevent="dialogPagamento = !dialogPagamento">Cancelar</v-btn>
                    <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 13px;color:#ffffff;"
                        @click.prevent="AtualizaPagamento()">Atualizar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaSinistrosAcordoParcelasView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        itemsSelected: [],
        searchValue: '',
        MostraGrid: true,
        headers: [],
        ListSinistros:[],
        ListSinistrosGeral:[],
        itemAtual: [],
        dialogPagamento:false,
        TituloPagamento: {
            stpId: 0,
            sttId: 0,
            cusId: null,
            stpDtPagamento: null,
            stpValorPrincipal: 0,
            stpValorJuro: 0,
            stpValorMora: 0,
            stpValorTotal: 0,
            stpCodigoPagto: '',
            stpObservacao: ''
        },
        TituloPagamentoDocumento: {
            stdId: 0,
            stpId: null,
            cusId: null,
            stdDtInclusao: null,
            stdNomeOriginal: '',
            stdNomeInterno: '',
            docId: null
        }
    }),
    methods: {
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListSinistros = this.ListSinistrosGeral.filter(x=> x.sstIdAtual == value);
            }
            else{
                this.ListSinistros = this.ListSinistrosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/ListaSinistrosAcordoParcelas/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ListaSinistrosAcordoParcelas/GetFileByParam?param=${encodeURIComponent(rel)}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        VisualizarDocumento(item) {
            if (item) {
                this.openInNewTab(item);
            }
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Título", value: "sttId", sortable: true, });
            this.headers.push({ text: "Contratacao", value: "pedId", sortable: true, });
            this.headers.push({ text: "Cliente", value: "pedDescricao", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imoNome", sortable: true, });
            }
            this.headers.push({ text: "Descrição", value: "sttDescricao", sortable: true, });
            this.headers.push({ text: "Valor", value: "sttValorPrincipal", sortable: true, });
            this.headers.push({ text: "Vencimento", value: "sttDtVencimento", sortable: true, });
             this.headers.push({ text: "Tipo", value: "mpgNome", sortable: true, });
            this.headers.push({ text: "Status", value: "stlNome", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        ConfirmaPgto(item) {
            item.sttDtVencimento = this.$moment(item.sttDtVencimento).format('YYYY-MM-DD')
            this.TituloPagamento.sttId = item.sttId;
            this.TituloPagamento.stpValorPrincipal = this.formatarValor(item.sttValorPrincipal);
            this.itemAtual = item;

            this.dialogPagamento = true;
        },
        async AtualizaPagamento() {
            if (!this.TituloPagamento.stpDtPagamento) {
            return this.$mensagemAviso("Selecione Data Pagamento");
            }

            // Leia como strings da UI e converta localmente
            const p = this.parseBR(this.TituloPagamento.stpValorPrincipal);
            const j = this.parseBR(this.TituloPagamento.stpValorJuro || '0');
            const m = this.parseBR(this.TituloPagamento.stpValorMora  || '0');
            const total =  Math.round((p + j + m) * 100) / 100;

            const payload = {
            // mantenha os ids/refs que precisa
            ...this.pickIds(this.TituloPagamento), // opcional: pegue só o que importa
            cusId: this.User.cusid,
            stpDtPagamento: this.$moment(this.TituloPagamento.stpDtPagamento)
                                .format('YYYY-MM-DDTHH:mm:ss'),
            stpValorPrincipal: p,
            stpValorJuro: j,
            stpValorMora: m,
            stpValorTotal: total
            };
             const resp = await axios.post('/Telas/ListaSinistrosAcordoParcelas/AddSinistroTituloPagamento', payload);
             const novoIdStpId = resp.data;

            //verifica se tem documentos
             if (novoIdStpId > 0) {
                 if (this.selectedFileDebito != '' && this.selectedFileDebito != null) {
                    try {
                        const uploadSuccess = await this.UploadImg(this.selectedFileDebito[0]);

                        if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
                            this.TituloPagamentoDocumento.stpId = novoIdStpId;
                            this.TituloPagamentoDocumento.cusId = this.User.cusid;
                            this.TituloPagamentoDocumento.stdDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss');
                            this.TituloPagamentoDocumento.stdNomeOriginal = this.selectedFileDebito[0].name;
                            this.TituloPagamentoDocumento.stdNomeInterno = uploadSuccess.data.nameFile;
                            this.TituloPagamentoDocumento.docId = 5;
                            await axios.post('/Telas/ListaSinistrosAcordoParcelas/AddSinistroTituloPagamentoDocumento', this.TituloPagamentoDocumento);
                            // Limpa seleções
                            this.selectedFileDebito = '';
                            this.dialogPagamento = false;
                            this.Get();
                        } else {
                            this.$mensagemErro("Erro inesperado ao processar o arquivo. Tente novamente.");
                        }
                    } catch (error) {
                        // Trata erro retornado pelo backend (ex: BadRequest)
                        const mensagem = error.response?.data || "Erro ao enviar o documento.";
                        this.$mensagemErro(mensagem);
                    }
                }
             }
             else{
                this.dialogPagamento = false;
                this.Get();
             }
        },
         pickIds(t) {
            // retorne apenas campos identificadores que o backend exige
            const { stpId, sttId,stpCodigoPagto,stpObservacao } = t || {};
            return { stpId, sttId,stpCodigoPagto,stpObservacao };
        },
        parseBR(v) {
            if (v === null || v === undefined || v === '') return 0;
            // remove pontos de milhar e troca vírgula por ponto
            return parseFloat(String(v).replace(/\./g, '').replace(',', '.')) || 0;
        },
        formatBR(n) {
            if (n === null || n === undefined || isNaN(n)) return '';
            return Number(n).toFixed(2).replace('.', ',');
        },
        async Get() {
              await axios.get(`/Telas/ListaSinistrosAcordoParcelas/GetDados`)
                .then(response => {
                    this.ListSinistrosGeral = response.data.sinistroTitulos.sort(
                        (a, b) => (b.sttDtVencimento || '').localeCompare(a.sttDtVencimento || '')
                        ).reverse();
                    this.ListSinistros = this.ListSinistrosGeral;
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;
                    this.User.cusid = response.data.cusId;

                    //console.log('this.ListSinistrosGeral')
                    //console.log(this.ListSinistrosGeral)                
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
    computed: {
        totalRaw() {
        const p = this.parseBR(this.TituloPagamento.stpValorPrincipal);
        const j = this.parseBR(this.TituloPagamento.stpValorJuro);
        const m = this.parseBR(this.TituloPagamento.stpValorMora);
        return p + j + m;
        },
        totalBR() {
        return this.formatBR(this.totalRaw);
        }
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
</style>
